<template>
  <div class="wrap area main-container" ref="outerDom">
    <!--  -->
    <div class="flexible-scollscreen position-fixed">
      <div class="puzzle-container position-absolute"></div>
    </div>
    <!-- 内容 -->
    <div class="pz-normal-scroll-container position-relative">
      <div class="pz-container-top position-relative">
        <div class="pz-reg-bg position-fixed d-flex justify-content-center align-items-center cursor" v-if="navFlag">
          <!-- <div class="pz-lf-reg-btn" @click="handleShowMail()"></div>
          <div class="pz-lr-reg-btn">
            <div class="apple-btn btn-size " @click="AS_reg('as')"></div>
            <div class="google-btn btn-size mt-8" @click="GP_reg('gp')"></div>
          </div> -->

          <div class="apple-btn btn-size " @click="AS_reg('as')"></div>
          <div class="google-btn btn-size " @click="GP_reg('gp')"></div>
        </div>
      </div>
      <div class="pz-container-cont position-relative ">
        <div class="pz-container-bg position-absolute"></div>
        <!-- 内容区域 -->
        <div class="pz-container-wrapper">
          <ul class="rightList">
            <li id="id0" ref="idref" :class="{ test: true, testenter: testShow }">
              <reserve />
            </li>
            <li id="id1" ref="id1ref" :class="{ test: true, testenter: test1Show }">
              <rolePage />

            </li>
            <li id="id2" ref="id2ref" :class="{ test: true, testenter: test2Show }">
              <worldview @showVideo="videoFlag = true" />
            </li>
            <li id="id3" ref="id3ref" :class="{ test: true, testenter: test3Show }">
              <info />
            </li>
          </ul>
        </div>
      </div>
    </div>


    <div class="navgator" v-if="navgatorFlag">
      <div class="icon-position d-flex cursor">
        <div class="twi-icon icon-size" @click="Twitter_page('twi')"></div>
        <div class="sns-icon icon-size ml-12" @click="youtube_page('sns')"></div>
      </div>
      <ul v-if="menuFlag" class="
        menu-list
        position-absolute
      ">
        <li class="navgatorLi cursor" :class="{ isActive: index === navgatorIndex }" @click="handleLeft(index)"
          v-for="(item, index) in navgator" :key="index">
          <div :class="index == navgatorIndex ? 'choose-menu' : ''">
            {{ item.text }}
          </div>
        </li>
      </ul>
      <div class="reg-btn-position position-absolute cursor">
        <div class="buy-btn btn-size " @click="buy_reg('buy')"></div>
        <div class="apple-btn btn-size  mt-6" @click="AS_reg('as')"></div>
        <div class="google-btn btn-size mt-6" @click="GP_reg('gp')"></div>
      </div>
      <!-- <div class="mail position-absolute cursor" @click="handleShowMail()">
      </div> -->
      <div class="arrow position-absolute cursor" @click="handleTop()">
      </div>
    </div>
    <div class="footer">
      <div class="d-flex flex-direction-column align-items-center justify-content-center">
        <div class="f-logo"></div>
        <div class="size-16 privacy">
          <a href="https://useragreement.ujoygames.jp/" class="pl-12 pr-12" target="_blank">利用規約</a>
          <a href="https://privacy.ujoygames.jp/" class="pl-12 pr-12" target="_blank">プライバシーポリシー</a>
          <a href="https://www.aventuratales.jp/faq/index.html" class="pl-12 pr-12" target="_blank">お問い合わせ</a>

        </div>
        <!-- <div class="t-txt"></div> -->
        <a href="https://commerce.ujoygames.jp/" class="t-txt" target="_blank">特定商取引法に基づく表記</a>

        <div class="f-bottom"></div>
      </div>
    </div>

    <!-- 预约弹出框 -->
    <!-- <div class="model position-fixed" v-if="mailFlag">
      <register @closeMail="mailFlag = false" />
    </div> -->
    <!-- 视频弹出框 -->
    <div class="model position-fixed" v-if="videoFlag">
      <div class="video-bg position-relative ">
        <div class="close position-absolute cursor" @click="videoFlag = false"></div>
        <div class="embed-responsive-16by9">
          <video loop autoplay class="videobox position-absolute" :style="scaleStyle">
            <source src="https://resource-mp4.ujoygames.com/toa/ujoyJpCV.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import reserve from "./mainComponents/reserve";
import rolePage from "./mainComponents/rolePage";
import worldview from "./mainComponents/worldview";
import info from "./mainComponents/info";
// import register from "./mainComponents/register";




export default {
  components: {
    reserve,
    rolePage,
    worldview,
    info,
    // register
  },
  data() {
    return {
      testShow: false,
      test1Show: false,
      test2Show: false,
      test3Show: false,



      videoFlag: false,

      // mailFlag: false,
      navgatorFlag: false,
      navFlag: true,
      menuFlag: true,
      navgator: [
        {
          id: 0,
          text: '予約特典',
        },
        {
          id: 1,
          text: 'キャラクター情報',
        },
        {
          id: 2,
          text: 'ストーリー',
        },
        {
          id: 3,
          text: 'ゲーム情報',
        },
      ],
      navgatorIndex: 0,
      navgatorIndexShow: false, // 是否显示
      listBox: ["A", "B", "C", "D"],
      listBoxState: true, //点击导航栏时，暂时停止监听页面滚动
      scrollTrigger: false, //默认初始值
      scrollTop: 0, //默认距离顶部的距离
    };
  },
  created() { },
  mounted() {
    let timeId;
    window.addEventListener(
      "scroll",
      () => {
        // 页面滚动停止100毫秒后才会执行下面的函数。
        clearTimeout(timeId);
        timeId = setTimeout(() => {
          this.scrollToTop();
          // console.log("执行完了哦");
        }, 100);
      },
      true
    );

    // window.addEventListener("scroll", this.scrollNavTop());
  },

  methods: {
    handleTop() {


      // 获取当前距离顶部的距离
      let scrollTop = this.scrollTop;

      document.body.scrollTop = 0


    },
    // 点击显示mail
    // handleShowMail() {
    //   this.mailFlag = true
    // },
    buy_reg(val) {
      this.common.goShare(val);
    },
    // AS_reg
    AS_reg(val) {
      this.common.goShare(val);
    },
    // 跳转到goole
    GP_reg(val) {
      this.common.goShare(val);
    },
    Twitter_page(val) {
      this.common.goShare(val);
    },
    youtube_page(val) {
      this.common.goShare(val);
    },
    updateMenu(params) {
      this.menuFlag = params;
    },
    // 点击导航菜单，页面滚动到指定位置
    handleLeft(index) {
      this.navgatorIndex = index;

      this.$el.querySelector(`#id${index}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start",

      });
      this.listBoxState = false;

      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 200);
    },
    // 监听页面元素滚动，改变导航栏选中
    scrollToTop() {

      // 获取视窗高度
      var domHight = document.body.offsetHeight;
      // dom滚动位置
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      this.scrollTop = scrollTop
      // 菜单显示
      if (scrollTop >= 400) {
        this.navgatorFlag = true;
      } else {
        this.navgatorFlag = false;
      }

      // 首页按钮隐藏/显示
      if (scrollTop >= 200) {
        this.navFlag = false;
      } else {
        this.navFlag = true;
      }
      if (this.listBoxState) {
        //作用是点击导航栏时，延迟这里执行。
        this.listBox.map((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop = document.getElementById(`id${i}`).offsetTop;

          // 动画
          if (scrollTop >= this.$refs.idref.offsetTop - 100) {
            this.testShow = true;
          }
          if (scrollTop >= this.$refs.id1ref.offsetTop - 100) {
            this.test1Show = true;
          } if (scrollTop >= this.$refs.id2ref.offsetTop - 100) {
            this.test2Show = true;
          } if (scrollTop >= this.$refs.id3ref.offsetTop - 100) {
            this.test3Show = true;

          }

          // 获取监听元素本身高度
          var scrollHeight = document.getElementById(`id${i}`).scrollHeight;
          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
            // 导航栏背景色选中
            this.navgatorIndex = i;
          }
        });
      } else {
      }
    },
  },
  destroyed() {
    window.removeEventListener(
      "scroll",
      () => {
        this.scrollToTop();
        // console.log("销毁完了哦");
      },
      true
    );
  },
};
</script>

<style lang='scss'>
.area {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  overflow: hidden;
}

.wrap {
  width: 100%;
  background: #ededed;
  max-width: 1920px;
  width: 1920px;
  margin: 0 auto;
}

.main-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

.buy-btn {
  background: url("../assets/img/reg-buy.png") no-repeat center top;
  background-size: 100% 100%;
  margin-right: 16px;
}
.apple-btn {
  background: url("../assets/img/reg-apple.png") no-repeat center top;
  background-size: 100% 100%;
  margin-right: 16px;
}

.google-btn {
  background: url("../assets/img/reg-google.png") no-repeat center top;
  background-size: 100% 100%;
}

.flexible-scollscreen {
  z-index: 0;
  height: 100%;
  top: 0;

  .puzzle-container {
    background: url("../assets/img/puzzle.png") no-repeat center top;
    width: 1920px;
    height: 1086px;
    background-size: 100% 100%;
    top: 0;
    left: 0;
  }
}

.pz-normal-scroll-container {
  width: 100%;
  height: auto;
  min-height: 100vh;

  .pz-container-top {
    overflow: visible;
    width: 1920px;
    height: 950px;


    .pz-reg-bg {
      background: url("../assets/img/pz-reg-bg.png") no-repeat center top;
      width: 496px;
      height: 156px;
      background-size: 100% 100%;
      transform: translate(-50%, 0);
      left: 50%;
      top: 650px;
      transition: all 0.1s ease-in-out;

      .btn-size {
          width: 201px;
          height: 61px;
        }

      .pz-lf-reg-btn {
        background: url("../assets/img/reg-btn.png") no-repeat center top;
        width: 231px;
        height: 183px;
        background-size: 100% 100%;
      }

    }

  }

  .pz-container-cont {
    overflow: visible;
    width: 1920px;
    height: auto;

    .pz-container-bg {
      background: url("../assets/img/bg.png") no-repeat center top;
      width: 1920px;
      height: 6002px;
      background-size: 100% 100%;
      top: -380px;
      left: 0;
      pointer-events: none;
      transition: all .2s;
    }

    .pz-container-wrapper {
      background: center center / cover no-repeat;
      overflow: visible;
      position: relative;
      width: 1920px;
      top: 300px;
    }
  }

}


.navgator {
  background: url("../assets/img/menu/shadow-nav.png") no-repeat center top;
  width: 209px;
  height: 817px;
  background-size: 100% 100%;
  position: fixed;
  top: 45px;
  right: 45px;
  z-index: 2;

  .reg-btn-position {
    top: 430px;
    left: 40px;

    .btn-size {
      width: 129px;
      height: 39px;
    }
  }

  .mail {
    background: url("../assets/img/menu/mail.png") no-repeat center top;
    background-size: 100% 100%;
    bottom: 186px;
    left: 18px;
    width: 156px;
    height: 94px;
  }

  .arrow {
    background: url("../assets/img/menu/arrow.png") no-repeat center top;
    background-size: 100% 100%;
    bottom: 95px;
    left: 90px;
    width: 37px;
    height: 35px;
  }

  .icon-position {
    position: absolute;
    top: 135px;
    left: 60px;

    .twi-icon {
      background: url("../assets/img/menu/twi.png") no-repeat center top;
      background-size: 100% 100%;
    }

    .sns-icon {
      background: url("../assets/img/menu/sns.png") no-repeat center top;
      background-size: 100% 100%;
    }

    .icon-size {
      width: 36px;
      height: 36px;
    }
  }

  .menu-list {
    top: 229px;
    width: 100%;
  }

  .navgatorLi {
    text-align: center;
    font-family: KozMinStd-Bold;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #f2fcff;
    height: 48px;
    line-height: 48px;


  }

  .choose-menu {
    width: 202px;
    height: 54px;
    line-height: 52px;
    background: url("../assets/img/menu/choose.png") no-repeat center top;
    background-size: 100% 100%;
    color: #3484a7;
    font-weight: bold;
    margin-top: -6px;
    margin-left: 5px;
  }

  .isActive {
    color: #fff;
  }
}

.rightList {
  li {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // border: 1px solid #ccc;
  }
}

.footer {
  width: 1920px;
  height: 439px;
  background-color: #001b45;
  opacity: 0.93;

  .f-logo {
    background: url("../assets/img/f-top.png") center top;
    background-size: 100% 100%;
    width: 575px;
    height: 154px;
    margin-top: 32px;
  }

  .f-bottom {
    background: url("../assets/img/f-bottom.png") center top;
    background-size: 100% 100%;
    width: 1086px;
    height: 102px;
  }

  .privacy {
    margin: 41px 0 8px 0;
  }
  .t-txt {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 16px;
    color: #f2fcff;
    display: block;
  }
  a {
    border-right: 2px solid #2a2a2a;
  }

  a:last-child {
    border-color: transparent !important;
  }
}


// 视频
.video-bg {
  background: url("../assets/img/worldview/video-bg.png") no-repeat center top;
  background-size: 100% 100%;
  width: 1020px;
  height: 676px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .close {
    background: url("../assets/img/worldview/close.png") no-repeat center top;
    background-size: 100% 100%;
    width: 120px;
    height: 120px;
    top: 0;
    right: 0;
  }

  .videobox {
    width: 782px;
    height: 435px;
    top: 127px;
    left: 85px;
  }


}

.testenter {
  transform: translateY(0%) !important; //滚动后的位置
  opacity: 1 !important; //滚动后显现
  transition: all .5s ease;
}

.test {
  transform: translateY(10%); //滚动前的位置
  opacity: 0; //滚动前设置透明隐藏
}

@media (min-width:3440px) {
  .navgator {
    width: 168px !important;
    height: 654px !important;
  }

  .icon-position {
    top: 104px !important;
    left: 48px !important;

    .icon-size {
      width: 29px !important;
      height: 29px !important;
    }
  }

  .menu-list {
    top: 183px !important;

    .navgatorLi {
      height: 43px !important;
      line-height: 43px !important;
      font-size: 16px !important;
    }
  }

  .choose-menu {
    width: 162px !important;
    height: 43px !important;
    margin-top: -6px !important;
  }

  .reg-btn-position {
    top: 360px !important;
    left: 38px !important;

    .btn-size {
      width: 104px !important;
      height: 32px !important;
    }
  }

  .mail {
    bottom: 149px !important;
    left: 15px !important;
    width: 125px !important;
    height: 75px !important;
  }

  .arrow {
    bottom: 75px !important;
    left: 70px !important;
    width: 37px;
    height: 35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/MainIndex.vue